import React from 'react';
import jwtDecode from 'jwt-decode';
import { BrowserRouter } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { proposalActions, authActions, qprActions, teamActions } from './Actions';

import './App.css';

import ScrollToTop from './Hooks/ScrollToTop';
import Routes from './Partials/Routes';
import Header from './Partials/Header';
import Footer from './Partials/Footer';

function App() {
  const dispatch = useDispatch();
	let auth = {token: localStorage.getItem('token')};
	let team = localStorage.getItem('team');
	let proposal = localStorage.getItem('proposal');
	let qpr = localStorage.getItem('qpr');
	let qpr_data = localStorage.getItem('qpr_data');
	if (auth && auth.token) {
    auth.user = jwtDecode(auth.token);
    dispatch(authActions.login(auth));
	}
	if (team && Object.keys(team).length>0) {
    team = JSON.parse(team);
    dispatch(teamActions.team(team));
	}
  if(proposal && Object.keys(proposal).length>0) {
    proposal = JSON.parse(proposal);
    dispatch(proposalActions.proposal(proposal));
  }
  if(qpr && Object.keys(qpr).length>0) {
    qpr = JSON.parse(qpr);
    dispatch(qprActions.qpr(qpr));
  }
  if(qpr_data && Object.keys(qpr_data).length>0) {
    qpr_data = JSON.parse(qpr_data);
    dispatch(qprActions.qprData(qpr_data));
  }
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <Routes />
      <Footer />
    </BrowserRouter>
  );
}

export default App;